import gql from 'graphql-tag'

export const createMyUserBillingAddressMutation = gql`
mutation createMyUserBillingAddress($addressInput: UserBillingAddressInput!) {
    createMyUserBillingAddress(address: $addressInput) {
        id
    }
}
`
